import { AutenticacionService } from './../../../services/autenticacion.service';
import { CerrarSessionModalComponent } from './../cerrar-session-modal/cerrar-session-modal.component';
import { ConstantsService } from './../../../services/constants.service';
import { Component, OnInit, ViewChild } from '@angular/core';
declare var $;

@Component({
  selector: 'app-left-sidebar',
  templateUrl: './left-sidebar.component.html',
  styleUrls: ['./left-sidebar.component.scss']
})
export class LeftSidebarComponent implements OnInit {

  @ViewChild(CerrarSessionModalComponent) public cerrarSessionModal: CerrarSessionModalComponent;
  version:string;

  public isAdmin = false;
  public isExecutive = false;
  public isUser = false;
  public isGestorGastos = false;
  public isFondeador = false;
  public isEjecutivoFondeador = false;
  public isEjecutivoReportero = false;

  constructor(
    private constantsService: ConstantsService, 
    private authService: AutenticacionService){
    this.version = "version " + constantsService.versionNumber;
  }

  ngOnInit() {
    $.App.init();
    this.checkUserPermissions();
  }

  cerrarSession() {
    this.cerrarSessionModal.open();
  }

  hasPermission(permissionId) {
    return true;
  }

  hasPermissions(permissionsIds) {
    return true;
  }

  public checkUserPermissions(){
    this.isAdmin = this.authService.isAdmin();
    this.isExecutive = this.authService.isExecutive();
    this.isUser = this.authService.isUser();
    this.isGestorGastos = this.authService.isGestorGastos();
    this.isFondeador = this.authService.isFondeador();
    this.isEjecutivoFondeador = this.authService.isEjecutivoFondeador();
    this.isEjecutivoReportero = this.authService.isEjecutivoReportero();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/partials/left-sidebar/left-sidebar.component.ts